/* eslint-disable @typescript-eslint/no-explicit-any */
export let State;
(function (State) {
  State["Init"] = "Init";
  State["Pending"] = "Pending";
  State["Done"] = "Done";
  State["Error"] = "Error";
})(State || (State = {}));